import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('@/views/User/Login.vue'),
  },
  //登录
  {
    path: '/Login',
    component: () => import('@/views/User/Login.vue'),
  },
  //注册
  {
    path: '/Register',
    component: () => import('@/views/User/Register.vue'),
  },
  //忘记密码 - 邮箱
  {
    path: '/Forget',
    component: () => import('@/views/User/Forget.vue'),
  },
  //忘记密码 - 短信
  // {
  //   path: '/Messages',
  //   component: () => import('@/views/User/Messages.vue'),
  // },
  //重置密码
  {
    path: '/Reset',
    component: () => import('@/views/User/Reset.vue'),
  },
  // 个人中心 - 购买授权 - 商店
  {
    path: '/Center/Shop',
    component: () => import('@/views/Center/Shop.vue'),
  },
  // 个人中心 - 订单
  {
    path: '/Center/Orders',
    component: () => import('@/views/Center/Orders.vue'),
  },
  // 个人中心 - 下载
  {
    path: '/Center/Download',
    component: () => import('@/views/Center/Download.vue'),
  },
  // 个人中心 - 手册
  {
    path: '/Center/Manual',
    component: () => import('@/views/Center/Manual.vue'),
  },
  // 个人中心 - 我的
  {
    path: '/Center/My',
    component: () => import('@/views/Center/My.vue'),
  },
  // 支付宝跳转中间页
  {
    path: '/PayRedirect',
    component: () => import('@/views/AliPay/PayRedirect.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash', //history
  base: process.env.BASE_URL,
  routes,
});

export default router;
